import { render, staticRenderFns } from "./YouTubePlatformIcon.vue?vue&type=template&id=3d4c160a&scoped=true"
import script from "./YouTubePlatformIcon.vue?vue&type=script&lang=js"
export * from "./YouTubePlatformIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4c160a",
  null
  
)

export default component.exports